import "./styles.css"
import { ReactComponent as PlusIcon } from "../../../assets/svg/icons/plus.svg";
import { useEditOnboarding } from "../../../hooks/useEditOnboarding";
import TableVisualizationRow from "./TableVisualizationRow/Index";
import { Loading } from "../../Loading/Index";
import { useTranslation } from "react-i18next";
import { TranslatedHeader } from "../TranslatedHeader";

interface TablePastureManagementProps {
  listTable: IMicroAreaManagementContent[];
  isLoading: boolean;
  isHistory: boolean;
}

export default function TablePastureManagement({ listTable, isLoading, isHistory }: TablePastureManagementProps) {
  const { t } = useTranslation();

  const {
    setOptionForm,
  } = useEditOnboarding();

  return (
    <>
      {listTable && listTable.length > 0 ?
        <>
          <table className="tableTaskEvaluation" style={{ minWidth: 1280 }} id="tablePastureManagement">
            <thead>
              <tr>
                <th>{t("tables.initials")}</th>
                <th>{t("tables.farm")}</th>
                <th>{t("tables.area")}</th>
                <th>{t("tables.paddocks")}</th>
                <th>{t("tables.grazingType")}</th>
                <th>{t("tables.frequency")}</th>
                <th><TranslatedHeader value={t("tables.startDate")} /></th>
                {isHistory && <th><TranslatedHeader value={t("tables.endDate")} /></th>}
                <th />
              </tr>
            </thead>

            <tbody>
              {listTable.map(management =>
                <TableVisualizationRow key={management.id} microAreaManagement={management} isHistory={isHistory} />
              )}
            </tbody>
          </table>

          {isLoading && (
            <div className="tableLoadingOverlay">
              <div className="lds-ring">
                <div></div>
                <div></div>
              </div>
            </div>
          )}
        </>
        :
        isLoading
          ?
          <div className="emptyTable_container">
            <Loading visible={true} />
          </div>
          :
          <div className="emptyTable_container">
            <span>{t("commonUi.noResults")}</span>
          </div>
      }
    </>
  )
}
